import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useSelector } from '@ecommerce/nest-ssr/common';
import Icon from 'atomic/icon';
import WidgetDSAInterface from 'modules/shared/widgets/interfaces/widgets-data/widget-dsa.interface';
import { encryptData } from 'helpers/security';
import { AdsConfigInterface } from 'modules/ads-module/ads-config.interface';
import { IconProps } from 'atomic/icon/icon.interface';
import { getDSAUrl } from 'modules/shared/widgets/components/widget-dsa/helpers/dsa-helpers';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './widget-dsa.scss';

interface WidgetDSAProps {
    className?: string;
    size?: IconProps['size'];
    color?: IconProps['color'];
    dsa: WidgetDSAInterface;
}

const ADP_API_NETWORK = 4178463;

const WidgetDSA: React.FC<WidgetDSAProps> = ({ className, dsa, size, color = 'primary' }) => {
    const ads = useSelector((state: { ads: AdsConfigInterface; }) => state.ads);
    const [encryptDsaData, setEncryptDsaData] = useState('');

    useEffect(() => {
        let dsaData = null;

        if (dsa.isLineitemId && dsa.advertiserId) {
            dsaData = { advertiser_id: dsa.advertiserId };
        }

        if (!dsa.isLineitemId && dsa.advertiserName && dsa.paidName) {
            dsaData = { advertiser_name: dsa.advertiserName, paid_name: dsa.paidName };
        }

        if (dsaData && ads?.dsaCryptoKey) {
            try {
                encryptData(JSON.stringify(dsaData), ads.dsaCryptoKey).then(data => {
                    setEncryptDsaData(data);
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error: any) {
                console.error(error.message);
            }
        }
    }, [dsa, ads, setEncryptDsaData]);

    if (!encryptDsaData) {
        return null;
    }

    return (
        <a
            className={classNames('widget-dsa', className)}
            href={getDSAUrl(ADP_API_NETWORK, encryptDsaData)}
            target={LinkTarget.BLANK}
            aria-label="Info"
            rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
        >
            <Icon
                name="info"
                color={color}
                size={size}
            />
        </a>
    );
};

export default WidgetDSA;
